import React, { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from "recharts";
import styles from "../../App.module.css";

const processarVendasIndividuais = (data, intervalo = 180) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    return data
        .filter((item) => {
            const dataFechamento = new Date(item.dataFechamento);
            dataFechamento.setHours(0, 0, 0, 0);
            const diferencaDias = (hoje - dataFechamento) / (1000 * 60 * 60 * 24);
            return diferencaDias <= intervalo;
        })
        .map((item) => ({
            data: new Date(item.dataFechamento).toISOString().split("T")[0],
            valor: (item.valor * 0.15).toFixed(2)
        }))
        .sort((a, b) => new Date(a.data) - new Date(b.data));
};

const GraficoParceiros = ({ rawData, intervaloDefault = 60 }) => {
    const [rangeDateSells, setRangeDateSells] = useState(intervaloDefault);

    if (!rawData || rawData.length === 0) return <p>Nenhum dado disponível para o gráfico.</p>;

    console.log("Dados brutos:", rawData);
    const dadosFormatados = processarVendasIndividuais(rawData, rangeDateSells);
    console.log("Vendas individuais para o gráfico:", dadosFormatados);

    const nomeDoParceiro = rawData[0]?.usuarioParceiro || "Vendas";

    const totalComissao = rawData
        .filter((item) => {
            const hoje = new Date();
            const dataVenda = new Date(item.dataFechamento);
            const diff = (hoje - dataVenda) / (1000 * 60 * 60 * 24);
            return diff <= rangeDateSells;
        })
        .reduce((total, item) => total + item.valor * 0.15, 0)
        .toFixed(2);

    return (
        <>
            <div style={{ marginBottom: "20px" }}>
                <label style={{ fontWeight: "bold", marginRight: "10px" }}>Selecionar período:</label>
                <select
                    value={rangeDateSells}
                    onChange={(e) => setRangeDateSells(parseInt(e.target.value))}
                    style={{ padding: "5px", borderRadius: "5px", fontSize: "16px" }}
                >
                    <option value={7}>Últimos 7 dias</option>
                    <option value={30}>Últimos 30 dias</option>
                    <option value={60}>Últimos 60 dias</option>
                    <option value={180}>Últimos 180 dias</option>
                </select>
            </div>

            <div style={{ width: '100%', height: 250 }}>
                <ResponsiveContainer>
                    <BarChart data={dadosFormatados}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="data" tickFormatter={(tick) => tick.split("-").reverse().join("/")} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="valor" fill="var(--corPrimaria)" name={nomeDoParceiro} />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            <div className={styles.cadastroClienteContainer}>

                <h3 >Vendas (últimos {rangeDateSells} dias)</h3>
                <h3 style={{ marginBottom: "10px" }}>Comissão total no período: <span style={{ color: 'green' }}>R$ {totalComissao}</span></h3>

                {rawData
                    .filter((item) => {
                        const hoje = new Date();
                        const dataVenda = new Date(item.dataFechamento);
                        const diff = (hoje - dataVenda) / (1000 * 60 * 60 * 24);
                        return diff <= rangeDateSells;
                    })
                    .sort((a, b) => new Date(b.dataFechamento) - new Date(a.dataFechamento))
                    .map((item) => {
                        const nomeLimitado = item.clienteNome.length > 10
                            ? item.clienteNome.slice(0, 10) + "***"
                            : item.clienteNome;
                        const comissao = (item.valor * 0.15).toFixed(2);

                        return (
                            <div key={item.id} style={{
                                background: "white",
                                borderRadius: "10px",
                                padding: "10px",
                                marginBottom: "10px",
                                width: "90%",
                                border: "4px solid var(--corPrimaria)"
                            }}>
                                <strong> Data: {item.dataFechamento.split("T")[0]}</strong>  <br />
                                {/* <strong> Comissão: <span style={{ color: 'green' }}> R$ {comissao}</span>  </strong><br /> */}
                                <strong> Cliente: {nomeLimitado}</strong><br />
                                <strong> Parceiro: {item.usuarioParceiro}</strong>
                            </div>
                        );
                    })}
            </div>
        </>
    );
};

export default GraficoParceiros;
